import React, { Component } from 'react'
import { Cta, Background, ContentContainer, Title, Subtitle, Button } from './styles'

class EmployeeCTA extends Component {
  render() {
    const { content, size, mt } = this.props

    return (
      <Cta size={size} mt={mt}>
        <Background style={{ backgroundImage: `url(${content.image})` }} />
        <ContentContainer>
          <Title>{content.title}</Title>
          {content.subtitle ? <Subtitle>{content.subtitle}</Subtitle> : null}
          <Button href={content.link.url} target={content.link.target}>
            {content.link.content}
          </Button>
        </ContentContainer>
      </Cta>
    )
  }
}

export default EmployeeCTA



// WEBPACK FOOTER //
// ./src/components/EmployeeCTA/index.js